import SearchSelectAllUsers from 'components/Reusable Components/SearchSelectAllUsers'
import React, {useState} from 'react'
import DatePicker from 'react-datepicker';
import { FormGroup, Label, Input, Container,Row,Col,Button, Table, Card, CardBody,CardHeader,CardFooter } from 'reactstrap';
import { manualClock,last20Clocks } from 'network/ApiAxiosSchedule';
import ToastComp from 'components/Reusable Components/ToastComp';
import Header from 'components/Headers/Header';
import HeaderEmpty from 'components/Headers/HeaderEmpty';

function ManualTimeClock() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [inOut, setInOut] = useState(true);
  const [toast, setToast] = useState(false);
  const [lastClocks, setLastClocks] = useState(null);

  const managerID = JSON.parse(localStorage.getItem('user'))._id
  const role = JSON.parse(localStorage.getItem('user')).role

  const onSelect = async(e)=>{
    setSelectedOption(e)
    fetchLast20Clocks(e.value)
  }

  const fetchLast20Clocks = async(id)=>{
    const resp = await last20Clocks(id)
    if(resp.data.success){
      setLastClocks(resp.data.clocks)
    }
  }

  const saveClock =async()=>{
    const resp = await manualClock(managerID,selectedOption.value,startDate,inOut,'Manager')
    if(resp.data.success){
      //setSelectedOption(null)
      setToast({
        type:'green', 
        tittle: inOut?'Clock In Saved' : 'Clock Out Saved',
        text:'Saved!!'
      })
      fetchLast20Clocks(selectedOption.value)
      //setLastClocks(null)
    }else{
      setToast({
        type:'red',
        tittle:'Error!!!',
        text:resp.data.msg
      })
    }
  }

  return (
    <>
      {role == "admin" ? <Header/> : <HeaderEmpty/>}
      <Container className='text-center mt-2'>
        <Card>
          <CardHeader>
            <Row>
              <Col>
                <h3>Employee: </h3>
              </Col>
              <Col>
                <SearchSelectAllUsers onSelect={onSelect}/>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Row>
              <Col>
                <FormGroup switch>
                  <Input
                    id='inOutChkBox'
                    type="switch"
                    checked={inOut}
                    onChange={() => { setInOut(!inOut);}}
                    style={{width:'50px',height:'50px'}}
                  />
                  <Label for='inOutChkBox' style={{marginLeft:'50px',marginTop:'20px'}} check>{inOut ? 'Clocking IN' : 'Clocking OUT'}</Label>
                </FormGroup>
              </Col>
              <Col>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  className='mt-4'
                  calendarStartDay={1}
                />
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Button className='mb-3' onClick={()=> saveClock()}>Save</Button>
          </CardFooter>
        </Card>
        <Row>
          {lastClocks != null &&<Table dark hover responsive striped>
            <thead>
              <tr> 
                <td colSpan="4">
                  Last Clocks from {selectedOption && selectedOption.label}
                </td>
              </tr>
              <tr>
                <th>
                  ClockIn
                </th>
                <th>
                  ClockOut
                </th>
                <th>
                  ClockIn2
                </th>
                <th>
                  ClockOut2
                </th>
              </tr>
            </thead>
            <tbody>
              {lastClocks.map((clockItem)=>{
                return <tr key={clockItem._id}>
                  <th scope="row">
                    {clockItem.ClockIn && clockItem.ClockIn.slice(0,16)}
                  </th>
                  <td>
                    {clockItem.ClockOut && clockItem.ClockOut.slice(0,16)}
                  </td>
                  <td>
                    {clockItem.ClockIn2 && clockItem.ClockIn2.slice(0,16)}
                  </td>
                  <td>
                    {clockItem.ClockOut2 && clockItem.ClockOut2.slice(0,16)}
                  </td>
                </tr>
              })}
            </tbody>
          </Table>}
        </Row>
        {toast && <ToastComp type={toast.type} tittle={toast.tittle} text={toast.text} />}
      </Container>
    </>
  )
}

export default ManualTimeClock